import {
    SET_USER,
    SET_REMEMBER_USER,
    UNSET_USER,
    SET_URL
} from '../mutation-types';
import user from "../../helpers/user";

const initialState = {
    uuid: null,
    username: null,
    password: null,
    roles: null,
    permissions: null,
    headquarters: null,
    url: null,
    firstname: null,
    lastname: null,
};

const mutations = {
    [SET_USER](state, payload) {
        state.uuid = payload.user.uuid;
        state.username = payload.user.username;
        state.roles = payload.user.roles;
        state.permissions = payload.user.permissions;
        state.headquarters = payload.user.headquarters;
        state.firstname = payload.user.firstname;
        state.lastname = payload.user.lastname;
    },
    [SET_URL](state, payload) {
        state.url = payload;
    },
    [UNSET_USER](state) {
        state.username = null;
        state.password = null;
        state.roles = null;
        state.permissions = null;
        state.headquarters = null;
        state.firstname = null;
        state.lastname = null;
    },
    [SET_REMEMBER_USER](state, payload) {
        state.username = payload.user.username;
        state.password = payload.user.password;
    }
};

const actions = {
    setUrl: (context, url) => {
        context.commit(SET_URL, {url})
    },
    setAuthUser: (context, user) => {
        context.commit(SET_USER, {user})
    },
    setRememberUser: (context, user) => {
        context.commit(SET_REMEMBER_USER, {user})
    },
    unsetAuthUser: (context) => {
        context.commit(UNSET_USER)
    }
};

const getters = {
    isLoggedIn: (state) => {
        return !!(state.username);
    },
    authUser: (state) => {
        if (state.permissions) {
            if (typeof state.permissions === 'object') {
                state.permissions = Object.keys(state.permissions).map((key) => {
                    return state.permissions[key];
                });
            }
        }

        if (state.permissions && state.permissions.length > 0) {
            return state;
        } else {
            return JSON.parse(user.getUser());
        }
    },
    getUrl: (state) => {
        return state.url;
    },
};

export default {
    state: initialState,
    mutations,
    actions,
    getters
}